export default "__VITE_ASSET__DhoLarxL__"